import ListZeroPage from 'components/Common/ListZeroPage'
import Spinner from 'components/Common/Spinner'
import MagnifierIcon from 'components/Icons/MagnifierIcon'
import PlusBoxIcon from 'components/Icons/PlusBoxIcon'
import NoteGroupBox from 'components/Page/Note/NoteGroupBox'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLazyGetAllNotesApiQuery } from 'redux/api/note_api'
import { taskModalHandler } from 'redux/slices/originModals'

const TaskDetailNoteClientModal = ({ parentData }) => {
	const [getNotes, { data, isFetching, isLoading }] =
		useLazyGetAllNotesApiQuery()
	const [search, setSearch] = useState(undefined)
	const [modalCondition, setModalCondition] = useState(false)
	const dispatch = useDispatch()
	useEffect(() => {
		if (!data) {
			getNotes({ search: search, taskId: parentData.id })
		} else {
			const search = setTimeout(() => {
				getNotes({ search: search, taskId: parentData.id })
			}, 300)
			return () => clearTimeout(search)
		}
	}, [search])

	return (
		<>
			<ListZeroPage data={data} isLoading={isLoading} isFetching={isFetching}>
				<div className='grid gap-8'>
					<NoteGroupBox inModal={true} data={data} />
				</div>
			</ListZeroPage>
		</>
	)
}

export default TaskDetailNoteClientModal
